// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/silikonfeder-als-bremselement/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSilikonfederAlsBremselementDE: PageEntry = {
  id: "example.produkte-silikonfeder-als-bremselement",
  locale: "de",
  slug: "produkte/silikonfeder-als-bremselement",
  seo: {
    title: "Silikonfeder als Bremselement | Dietz GmbH",
    description: "Besondere Haptik bei der Bewegung vom Ausströmer im Interieurbereich Ansprechende Haptik unabhängig von äußeren Temperatureinflüssen während der Betätigung. Eine unzertrennliche Ve",
  },
  type: "post",
  h1: "Silikonfeder als Bremselement",
  intro: "Besondere Haptik bei der Bewegung vom Ausströmer im Interieurbereich Ansprechende Haptik unabhängig von äußeren Temperatureinflüssen während der Betätigung. Eine unzertrennliche Verbindung von Silikon und Stanz- Umformteile wurde umgesetzt. Herstellung in einer vollautomatischen Fertigungslinie",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_hybrid_silikonfedern.jpg", alt: "Silikonfeder als Bremselement", width: 1400, height: 1120 }
  ],
};
